import { IAssetSummary } from "../api/fetchMaintenance";
import { Asset, AssetMetrics, AssetModel } from "../models/asset";
import { Scheduling } from "../models/schedule";

export const getAssetIdByChassis = (assets: any[], chassis: string): string | undefined => {
  return assets
    .find((asset) => asset.chassis === chassis)?.id;
}

export const getAssetIdsByChassisList = (assets: any[], chassisList: string[]): string[] => {
  return assets
    .filter((asset) => chassisList.includes(asset.chassis))
    .map((asset) => asset.id);
}

export const getAssetIdsByChassisListFromAssetSummary = (assets: IAssetSummary[], chassisList: string[]): string[] => {
  return assets
    .filter((asset) => chassisList.includes(asset.identification))
    .map((asset) => asset.id);
}

export const getChassisListFromAssetIds = (allAssets: Asset[], assetIds: string[]): string[] => {
  if(allAssets.length === assetIds.length) return [];
  
  return allAssets
    .filter((asset) => assetIds.includes(asset.id))
    .map((asset) => asset.chassis);
}

export const getChassisFromAssetName = (allAssets: Asset[], assetNames: string[]): string[] => {
  return allAssets
    .filter((asset) => assetNames.includes(asset.name))
    .map((asset) => asset.chassis);
}

export const getLastAssetMetrics = (asset: Asset, previousCheckups: Scheduling[]): AssetMetrics => {
  const lastCheckup = previousCheckups.sort((a, b) => (b?.odometer ?? 0) - (a?.odometer ?? 0))[0];
  
  if (!lastCheckup) {
    return {
      assetId: asset.id,
      odometer: asset.odometer,
      lastOdometerUpdate: asset.lastOdometerUpdate,
      hourmeter: asset.hourmeter,
      lastHourmeterUpdate: asset.lastHourmeterUpdate,
    };
  }
  
  const isScheduleOdometerGreater = (asset.odometer ?? 0) < (lastCheckup.odometer ?? 0);
  const isScheduleHourmeterGreater = (asset.hourmeter ?? 0) < (lastCheckup.hourmeter ?? 0);

  return {
    assetId: asset.id,
    odometer: isScheduleOdometerGreater ? lastCheckup?.odometer : asset?.odometer,
    lastOdometerUpdate: isScheduleOdometerGreater ? lastCheckup?.date : asset?.lastOdometerUpdate,
    hourmeter: isScheduleHourmeterGreater ? lastCheckup?.hourmeter : asset?.hourmeter,
    lastHourmeterUpdate: isScheduleHourmeterGreater ? lastCheckup?.date : asset?.lastHourmeterUpdate,
  }
}
export const getAssetModelToSelectOption = (id?: string, assetModels?: AssetModel[]) => {
  if(!id) return null;

  // Check if id is a UUID
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  if (uuidRegex.test(id)) {
    return assetModels?.find((model) => model.modelId === id) || null;
  }

  return { modelCode: id, description: id };
};

export const getAssetByChassis = (allAssets: Asset[], chassis: string): Asset | undefined => {
  return allAssets.find((asset) => asset.chassis === chassis);
}
